import { ApiTypes } from "types"

export const dummyCustomerDashboardPerfTestMeta: ApiTypes.Model.Pagination = {
  total: 2,
  per_page: 10,
  current_page: 1,
  last_page: 1,
  from: 1,
  to: 2,
}

export const dummyCustomerDashboardPerfTestHistory = [
  {
    device: {
      sn: "01-000-00001",
      where_installed_name: "Kitchen",
    },
    perftest: {
      perftest_id: 1,
      perftest_result_id: 1,
      action: "cooling",
      label: "Test 1",
      status: "Passed",
      time: "2024-11-07 09:43:50",
      temp_diff: 2.5,
    },
  },
  {
    device: {
      sn: "01-000-00001",
      where_installed_name: "Kitchen",
    },
    perftest: {
      perftest_id: 2,
      perftest_result_id: 2,
      action: "heating",
      label: "Test 2",
      status: "Issue",
      time: "2024-11-06 14:20:30",
      temp_diff: -0.5,
    },
  },
] as unknown as ApiTypes.Model.PerformanceTestHistory[]
